module.exports = __webpack_public_path__ + "static/img/sale1.1493912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sale1.png
// module id = kCEz
// module chunks = 1